// const CryptoJS = require("crypto-js");
// const pako = require("pako");
import MatchEnum from "~src/enums/MatchEnum";
import type {
  IMatch,
  IMatchLive,
  ICompetitions,
  ITeam,
  ILeague,
  IStage,
  IRound,
  IItemString,
  ILineups,
  IIncident,
  IPlayer,
  IStatistics,
  IIncidentStatistic,
} from "~src/interfaces";
import StatsEnum from "~src/enums/StatsEnum";

// export const decryptData = (data) => {
//   try {
//     const key = "itsasecret123";
//     const decrypted = CryptoJS.AES.decrypt(data, key);
//     const hexStr = CryptoJS.enc.Hex.stringify(decrypted);
//     const byteArray = hexStr.match(/.{1,2}/g).map((byte) => parseInt(byte, 16));
//     const decompressed = pako.inflate(byteArray, { to: "string" });
//     const matchesData = JSON.parse(decompressed);

//     return matchesData;
//   } catch (error) {
//     console.error("Error decrypting data:", error);

//     return null;
//   }
// };

export const parseMatchData = (matchDataString: string): Array<IMatch> => {
  if (!matchDataString) {
    return [];
  }

  const matchDataArray = matchDataString.split("!!");
  const matches = matchDataArray.map((matchString) => {
    const matchDetails = matchString.split("^");

    const agg_score = matchDetails[35] ? matchDetails[35].split("-") : [];
    const stats = matchDetails[37] ? JSON.parse(matchDetails[37]) : [];
    const halfTimeStatistics = matchDetails[39] ? JSON.parse(matchDetails[39]) : {};
    return {
      id: matchDetails[0],
      match_time: matchDetails[1] as unknown as number,
      half_start_time: matchDetails[2],
      competition_id: matchDetails[3],
      season_id: matchDetails[4],
      status_id: parseInt(matchDetails[5]),
      home_team_id: matchDetails[6],
      home_team: {
        id: matchDetails[6],
        name: matchDetails[7],
      } as unknown as ITeam,
      home_scores: [
        parseInt(matchDetails[8]),
        parseInt(matchDetails[9]),
        parseInt(matchDetails[10]),
        parseInt(matchDetails[11]),
        parseInt(matchDetails[12]),
        parseInt(matchDetails[13]),
        parseInt(matchDetails[14]),
      ],
      home_position: matchDetails[15],
      away_team_id: matchDetails[16],
      away_team: {
        id: matchDetails[16],
        name: matchDetails[17],
      } as unknown as ITeam,
      away_scores: [
        parseInt(matchDetails[18]),
        parseInt(matchDetails[19]),
        parseInt(matchDetails[20]),
        parseInt(matchDetails[21]),
        parseInt(matchDetails[22]),
        parseInt(matchDetails[23]),
        parseInt(matchDetails[24]),
      ],
      away_position: matchDetails[25],
      round: {
        stage_id: matchDetails[26],
        group_num: matchDetails[27],
        round_num: matchDetails[28],
      } as unknown as IRound,
      stage: {
        id: matchDetails[29],
        name: matchDetails[30],
        name_vi: matchDetails[38],
        mode: matchDetails[31] as unknown as number,
        group_count: matchDetails[32] as unknown as number,
        round_count: matchDetails[33] as unknown as number,
        order: matchDetails[34] as unknown as number,
      } as unknown as IStage,
      agg_score: agg_score as unknown as Array<number>,
      leg: matchDetails[36] ?? "",
      stats,
      half_time_statistics: halfTimeStatistics
    } as unknown as IMatch;
  });

  return matches;
};

export const parseCompetitionData = (
  competitionDataString: string
): Array<ICompetitions> => {
  if (!competitionDataString) {
    return [];
  }

  const competitionDataArray = competitionDataString.split("!!");
  const competitions = competitionDataArray.map((competitionString) => {
    const competitionDetails = competitionString.split("^");

    return {
      id: competitionDetails[0],
      name: competitionDetails[1],
      short_name: competitionDetails[2],
      type: competitionDetails[3] ? parseInt(competitionDetails[3]) : 0,
      popularity: competitionDetails[4] ? parseInt(competitionDetails[4]) : 0,
      primary_color: competitionDetails[5],
      secondary_color: competitionDetails[6],
      cur_season_id: competitionDetails[8],
      // short_name_vi: competitionDetails[9],
    } as unknown as ICompetitions;
  });

  return competitions;
};

export const parseMatchH2hData = (
  item: { [key: number]: any },
  homeTeamId: string,
  sportType = "football"
) => {
  const status_id = item[2];
  const Kick_off_time = item[4];
  const home_team_id = item[5][0];
  const away_team_id = item[6][0];
  const home_scores = item[5].slice(2, item[5].length);
  const away_scores = item[6].slice(2, item[6].length);

  let matchTimePlayer = null;
  if (MatchEnum.LIST_STATUS_PLAYING.includes(status_id)) {
    matchTimePlayer = getTimeDetailLive(status_id, Kick_off_time, sportType);
  } else if (status_id === MatchEnum.STATUS_END) {
    // matchTimePlayer = getResultText(status_id, home_scores, away_scores);

    const status = determineMatchOutcome(item, homeTeamId);
    let statusTxt = "";
    if (status === "win") {
      statusTxt = "Thắng";
    } else if (status === "draw") {
      statusTxt = "Hòa";
    } else {
      statusTxt = "Thua";
    }

    matchTimePlayer = {
      text: statusTxt,
      status_h2h: status,
    };
  }

  return {
    id: item[0],
    competition_id: item[1],
    status_id,
    match_time: item[3],
    Kick_off_time,
    home_scores,
    away_scores,
    home_team_id,
    away_team_id,
    match_time_player: matchTimePlayer,
  };
};

export const determineMatchOutcome = (
  matchData: { [key: number]: any },
  homeTeamId: string
) => {
  // Trích xuất số bàn thắng từ dữ liệu trận đấu
  let homeScore = matchData[5][2];
  let awayScore = matchData[6][2];

  // Trường hợp đá hiệp phụ
  // -1 nghĩa là không có dữ liệu
  if (matchData[5][7] > 0) {
    homeScore = matchData[5][7];
  }

  if (matchData[6][7] > 0) {
    awayScore = matchData[6][7];
  }

  const isActualHomeTeam = matchData[5][0] === homeTeamId;
  // Xác định trạng thái trận đấu dựa trên tổng số bàn thắng
  if (homeScore > awayScore) {
    return isActualHomeTeam ? "win" : "lose"; // Kiểm tra đội nhà có phải là đội mình quan tâm không
  } else if (homeScore === awayScore) {
    return "draw"; // Hòa
  } else {
    return isActualHomeTeam ? "lose" : "win"; // Đảo ngược kết quả nếu đội mình quan tâm không phải là đội nhà
  }
};

export const determineMatchOutcome1 = (match: IMatch, homeTeamId: string) => {
  const totalHomeGoals = match.home_scores[0];
  const totalAwayGoals = match.away_scores[0];

  const isActualHomeTeam = match.home_team?.id === homeTeamId;
  // Xác định trạng thái trận đấu dựa trên tổng số bàn thắng
  if (totalHomeGoals > totalAwayGoals) {
    return isActualHomeTeam ? "win" : "lose"; // Kiểm tra đội nhà có phải là đội mình quan tâm không
  } else if (totalHomeGoals === totalAwayGoals) {
    return "draw"; // Hòa
  } else {
    return isActualHomeTeam ? "lose" : "win"; // Đảo ngược kết quả nếu đội mình quan tâm không phải là đội nhà
  }
};

export const determineMatchResult = (match: IMatch, teamId: string) => {
  if (match.home_team?.id === teamId) {
    if (match.home_scores[0] > match.away_scores[0]) return "w";
    if (match.home_scores[0] < match.away_scores[0]) return "l";
  } else if (match.away_team?.id === teamId) {
    if (match.home_scores[0] < match.away_scores[0]) return "w";
    if (match.home_scores[0] > match.away_scores[0]) return "l";
  }
  return "d";
};

export const formatRateColor = (e: number) => {
  var colors = [
    "#FF203C",
    "#FF6600",
    "#FFAE0F",
    "#C1CC01",
    "#5CB400",
    "#0E8604",
  ];

  if (e < 6) return colors[0];
  if (e >= 6 && e <= 6.49) return colors[1];
  if (e >= 6.5 && e <= 6.99) return colors[2];
  if (e >= 7 && e <= 7.99) return colors[3];
  if (e >= 8 && e <= 8.99) return colors[4];
  if (e >= 9) return colors[5];

  return void 0;
};

const getCurrentDateTimestamp = () => {
  const currentDateTimestamp = Math.floor(Date.now() / 1000);

  return currentDateTimestamp;
};

const timestampToMinutesSeconds = (timestamp: number) => {
  const minutes = Math.floor(timestamp / 60);
  const seconds = timestamp % 60;

  return { minutes, seconds };
};

export const getTimeDetailLive = (
  statusId: number,
  startTimestamp = 0,
  sportType = "football"
) => {
  const stautsText = MatchEnum.MATCH_STATUS_TEXT as { [key: string]: any };
  const statusTxt = stautsText[statusId] || "";
  let timePlayerProcess = 0;

  if (statusId !== 3 && (sportType === "basketball" || !startTimestamp)) {
    return {
      text: statusTxt,
      process: timePlayerProcess,
    };
  }

  const currentDate: number = getCurrentDateTimestamp();
  const { minutes, seconds } = timestampToMinutesSeconds(
    currentDate - startTimestamp
  );
  const minutesApp: number = seconds > 0 ? minutes + 1 : minutes;

  // % thời gian đá
  const timeProcess = {
    2: minutesApp > 45 ? 50 : (minutesApp / 90) * 100,
    4: minutesApp + 45 > 90 ? 100 : ((45 + minutesApp) / 90) * 100,
    5:
      minutesApp + 90 > 105
        ? (105 / 120) * 100
        : ((90 + minutesApp) / 120) * 100,
    6: minutesApp + 105 > 120 ? 100 : ((105 + minutesApp) / 120) * 100,
  } as { [key: number]: any };

  const statusTimeTexts = {
    2:
      minutesApp > 45 ? `45+${Math.floor(minutesApp - 45)}'` : `${minutesApp}'`,
    4:
      minutesApp + 45 > 90
        ? `90+${Math.floor(minutesApp + 45 - 90)}'`
        : `${45 + minutesApp}'`,
    5: minutesApp + 90 > 105 ? "105+'" : 90 + minutesApp + "'",
    6: minutesApp + 105 > 120 ? "120+'" : 105 + minutesApp + "'",
  } as { [key: number]: any };

  const timeText = statusTimeTexts[statusId]
    ? `: ${statusTimeTexts[statusId]}`
    : "";

  timePlayerProcess = timeProcess[statusId] ? timeProcess[statusId] : 0;

  return {
    text: `${statusTxt}${timeText}`,
    process: timePlayerProcess,
  };
};

export const getTimeUtc = (time: any) => {
  const utcDateString = time.toUTCString();

  return new Date(utcDateString).getTime() / 1000;
};

export const unReverseId = (id: number) => {
  if (!id) {
    return id;
  }

  const sum = id
    .toString()
    .split("")
    .reduce((acc, digit) => acc + parseInt(digit, 10), 0);
  const firstNumber = sum < 10 ? 1 : parseInt(sum.toString()[0], 10);
  const lastNumber = sum < 10 ? sum : parseInt(sum.toString().slice(-1), 10);

  return parseInt(
    firstNumber + id.toString().split("").reverse().join("") + lastNumber
  );
};

export const addMatchDetailLive = async (
  matchs: Array<IMatch>,
  detailLive: Array<IMatchLive>,
  sportType = "football"
) => {
  const datas = [];
  for (const match of matchs) {
    const matchDetail = detailLive.find((item) => match.id === item.id);
    let newdata = {};
    if (matchDetail) {
      const status_id = matchDetail.score[1];
      const kickOffTime =
        sportType === "football" ? matchDetail.score[4] : matchDetail.timer[2];
      newdata = {
        match_time_player: getTimeDetailLive(status_id, kickOffTime, sportType),
        status_id: status_id,
        home_scores:
          sportType === "football"
            ? matchDetail.score[2]
            : matchDetail.score[3],
        away_scores:
          sportType === "football"
            ? matchDetail.score[3]
            : matchDetail.score[4],
      };
    } else {
      newdata = {
        match_time_player: getTimeDetailLive(match.status_id, 0, sportType),
      };
    }
    datas.push({
      ...match,
      ...newdata,
    });
  }

  return datas;
};

export const getCupStage = (match: IMatch) => {
  const stage = match.stage;
  const round = match.round as IRound;
  const stageTxts = {
    Group: "Bảng",
    Round: "Vòng",
    "Qualifying Round": "Vòng loại",
    "Group Stage": "Bảng",
    "1/8 Final": "Vòng 1/8",
    "Quarter-finals": "Tứ kết",
    "Quarter Final": "Tứ kết",
    "Semi-finals": "Bán kết",
    Semifinal: "Bán kết",
    "Third Place": "Trận tranh hạng 3",
    Final: "Chung kết",
  } as IItemString;

  const arr = [];
  if (!stage) {
    return "";
  }
  let stgName: string = stage.name_vi ? stage.name_vi : stage.name;
  if (stageTxts[stgName]) {
    stgName = stageTxts[stgName];
  } else {
    stgName = stgName.replace("Round", "Vòng");
  }
  arr.push(stgName);

  // 1 số trường hợp đã có sẳn bảng đấu ở trong state name
  const stgNameArr = stgName.split(" ");
  const groups = [
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "M",
    "N",
  ];
  if (
    stgNameArr.length === 0 ||
    !groups.includes(stgNameArr[stgNameArr.length - 1].toUpperCase())
  ) {
    if (round["group_num"] && round["group_num"] != 0) {
      arr.push(groups[round["group_num"] - 1]);
    }
  }

  const roundNum = round["round_num"];
  if (roundNum && roundNum != 0) {
    arr.push(`- Vòng ${roundNum}`);
  }

  return arr.join(" ");
};

export const getRoundName = (match: IMatch, type: number | undefined) => {
  // trường hợp ngoại lệ UEFA Nations League
  if (
    type === MatchEnum.STAGE_MODE_CUP ||
    match.competition_id === "d23xmvkh43oqg8n"
  ) {
    return getCupStage(match);
  } else if (type === MatchEnum.STAGE_MODE_LEAGUE) {
    const arrStage = [];
    // if (match.stage) {
    // const stage = match.stage;
    // if(stage) {
    //   arrStage.push(stage.name_vi ? stage.name_vi : stage.name);
    // }
    // }

    if (match.round?.round_num && match.round?.round_num != 0) {
      arrStage.push(`Vòng ${match.round.round_num}`);
    }

    return arrStage.join(" - ");
  }

  return "";
};

export const getPlayerNameShow = (player: IPlayer | undefined) => {
  if (player) {
    if (player.short_name_vi) {
      return player.short_name_vi;
    } else if (player.short_name) {
      return player.short_name;
    } else {
      return player.name;
    }
  }

  return "";
};

export const getTeamNameShow = (team: ITeam | undefined) => {
  if (team) {
    if (team.short_name_vi) {
      return team.short_name_vi;
    } else if (team.short_name) {
      return team.short_name;
    } else {
      return team.name;
    }
  }

  return "";
};

export const getTeamName = (teams: ITeam[], teamId: string) => {
  const team: any = teams.find((team: ITeam) => team.id === teamId);

  return getTeamNameShow(team);
};

export const getCompetitionNameShow = (competition: any) => {
  if (!competition) return "";

  return competition.short_name_vi || competition.short_name || competition.name || "";
};

export const getCompetitionName = (
  competitions: ILeague[],
  competitionId: string
) => {
  const competition: any = competitions.find(
    (competition: ILeague) => competition.id === competitionId
  );

  return getCompetitionNameShow(competition);
};

export const addIncidentToPlayer = (
  players: IPlayer[],
  incidents: IIncident[]
) => {
  let i = 0;
  for (const player of players) {
    // Tìm toàn bộ incidents của player
    const incidentPlayers = incidents.filter((item: IIncident) => {
      if (
        (item.player && item.player.id === player.id) ||
        (item.playerIn && item.playerIn.id === player.id) ||
        (item.playerOut && item.playerOut.id === player.id)
      ) {
        return true;
      }

      return false;
    });
    if (incidentPlayers.length) {
      // gán incident vào player
      for (const incident of incidentPlayers) {
        const check = player.incidents.find(
          (inci: IIncident) => inci.time == incident.time
        );
        if (!check) {
          if (incident.playerIn) {
            incident.in_player = incident.playerIn;
          }
          if (incident.playerOut) {
            incident.out_player = incident.playerOut;
          }
          players[i].incidents.push(incident);
        }
      }
    }
    i++;
  }

  return players;
};

export const addIncidentToLineup = (
  lineups: ILineups,
  incidents: IIncident[]
) => {
  if (incidents.length === 0 || !lineups || !lineups.id) {
    return lineups;
  }

  lineups.lineup.home = addIncidentToPlayer(lineups.lineup.home, incidents);
  lineups.lineup.away = addIncidentToPlayer(lineups.lineup.away, incidents);

  return lineups;
};

const calculatePercentage = (value: number, total: number): string => {
  if (total === 0) return "0%";
  return `${((value / total) * 100).toFixed(2)}%`;
};

export const getProcessedStats = (
  match: IMatch,
  statistics: IStatistics,
  isDefault: boolean
) => {
  const techKind: Record<string, string> = StatsEnum.techKind;

  const homeStat = statistics.stats.find(
    (stat: IItemString) => stat.team_id === match.home_team_id
  );
  const awayStat = statistics.stats.find(
    (stat: IItemString) => stat.team_id === match.away_team_id
  );

  // const homeStatAll = props.statisticAll.stats.find(
  //   (stat: IItemString) => stat.team_id === props.match.home_team_id
  // );
  // const awayStatAll = props.statisticAll.stats.find(
  //   (stat: IItemString) => stat.team_id === props.match.away_team_id
  // );

  if (!homeStat || !awayStat) return [];

  return Object.keys(techKind)
    .map((key) => {
      const homeVal = homeStat[key] < 0 ? 0 : homeStat[key];
      const awayVal = awayStat[key] < 0 ? 0 : awayStat[key];

      return {
        key,
        type: techKind[key],
        home: key === "ball_possession" ? `${homeVal}%` : homeVal,
        away: key === "ball_possession" ? `${awayVal}%` : awayVal,
        showHomePre: calculatePercentage(
          Number(homeVal),
          Number(homeVal) + Number(awayVal)
        ),
        showAwayPre: calculatePercentage(
          Number(awayVal),
          Number(homeVal) + Number(awayVal)
        ),
        winHome:
          Number(homeVal) > Number(awayVal) ? "as-statistics__home-win" : "",
        winAway:
          Number(awayVal) > Number(homeVal) ? "as-statistics__away-win" : "",
      };
    })
    .filter((stat) => {
      if (
        stat.key === "ball_possession" &&
        homeStat[stat.key] !== undefined &&
        awayStat[stat.key] !== undefined
      ) {
        return true;
      }

      if (
        isDefault &&
        homeStat[stat.key] !== undefined &&
        awayStat[stat.key] !== undefined
      ) {
        return true;
      }

      if (homeStat[stat.key] <= 0 && awayStat[stat.key] <= 0) {
        return false;
      }

      // if (
      //   !homeStatAll ||
      //   !awayStatAll ||
      //   (homeStatAll[stat.key] === 0 && awayStatAll[stat.key] === 0)
      // ) {
      //   return false;
      // }

      return !isNaN(Number(stat.home)) && !isNaN(Number(stat.away));
    });
};

export const getIncidentIcon = (
  player: IPlayer,
  incident: IIncidentStatistic | IIncident,
  isSubstituted = false
) => {
  const listIncidents: IIncidentStatistic[] = MatchEnum.INCIDENT_LIST;

  const inci: IIncidentStatistic | undefined = listIncidents.find(
    (item: IIncidentStatistic) => item.type === incident.type
  );

  if (inci) {
    if (inci.type === 1 && incident?.player?.id !== player.id) {
      const inci1: IIncidentStatistic | undefined = listIncidents.find(
        (item: IIncidentStatistic) => item.type === 1111
      );

      return inci1?.icon;
    } else if (
      inci.type === 9 &&
      incident?.in_player?.id === player.id &&
      isSubstituted
    ) {
      const inci1: IIncidentStatistic | undefined = listIncidents.find(
        (item: IIncidentStatistic) => item.type === 10
      );

      return inci1?.icon;
    }

    return inci.icon;
  }

  return null;
};

export const getScoresWithKey = (
  scores: Record<string, [number | string, number | string]>,
  __key = "p"
) => {
  const _home: (number | string)[] = [];
  const _away: (number | string)[] = [];

  const _data: (number | string)[][] = Object.entries(scores)
    .filter(([key]) => key.startsWith(__key))
    .map(([, value]) => value as [number | string, number | string]);

  _data.forEach(([home, away]) => {
    _home.push(home);
    _away.push(away);
  });

  return {
    home: _home,
    away: _away,
  };
};

export const initializeData = () => ({
  id: "",
  type: 100,
  stats: [StatsEnum.statsInit],
});

export const isObjectEmpty = (obj: any) => {
  return (
    obj == null || (Object.keys(obj).length === 0 && obj.constructor === Object)
  );
};

export const numberFormatShow = (number: any) => {
  return new Intl.NumberFormat("vi-VN").format(number);
};

export const viLocale = {
  months: [
    "Tháng 1",
    "Tháng 2",
    "Tháng 3",
    "Tháng 4",
    "Tháng 5",
    "Tháng 6",
    "Tháng 7",
    "Tháng 8",
    "Tháng 9",
    "Tháng 10",
    "Tháng 11",
    "Tháng 12",
  ],
  monthsShort: [
    "Th1",
    "Th2",
    "Th3",
    "Th4",
    "Th5",
    "Th6",
    "Th7",
    "Th8",
    "Th9",
    "Th10",
    "Th11",
    "Th12",
  ],
  weekdays: ["Chủ Nhật", "Thứ 2", "Thứ 3", "Thứ 4", "Thứ 5", "Thứ 6", "Thứ 7"],
  today: "Hôm nay",
  clear: "Xóa",
  confirm: "Đồng ý",
};

export const getPreferredFoot = (key: number) => {
  const text: { [key: number]: string } = {
    0: "N/A",
    1: "Chân trái",
    2: "Chân phải",
    3: "Cả 2 chân",
  };

  return text[key] ?? "";
};

export const getWeatherDetail = (weather: number) => {
  const weatherDetail: { [key: number]: string } = {
    1: "Mây rải rác",
    2: "Nhiều mây",
    3: "Mây rải rác/mưa",
    4: "Tuyết",
    5: "Nắng",
    6: "Âm u/mưa rào",
    7: "Âm u",
    8: "Sương mù nhẹ",
    9: "Nhiều mây và mưa",
    10: "Nhiều mây và mưa",
    11: "Nhiều mây/mưa dông",
    12: "Mây/mưa và dông cục bộ",
    13: "Sương mù"
  };

  return weatherDetail[weather] || "Không xác định";
};

export const isObjectNotEmpty = (obj: any) => {
  return obj && Object.keys(obj).length > 0;
};

export const isArrayNotEmpty = (arr: any[]) => {
  return arr && arr.length > 0;
};
